import { diContainer } from '../../libs/container';

type IKey = {
    [key: string]: any;
};

export class ApiUtils {
    private stringifyQuery(query: IKey) {
        const objectEntriesByQuery = Object.entries(query);
        let result = '';
        if (objectEntriesByQuery.length) {
            const sortedObjectEntriesByQuery = objectEntriesByQuery.sort().filter(objectEntry => objectEntry[1] !== undefined);
            sortedObjectEntriesByQuery.forEach(([key, value], i) => {
                let prefix = i === 0 ? '?' : '&';
                result += `${prefix}${key}=${value}`;
            });
        }
        return result;
    }

    private populateParamsInUrl(url: string, params: IKey) {
        const objectEntriesByParams = Object.entries(params);
        let result = url;
        if (objectEntriesByParams.length) {
            objectEntriesByParams.forEach(([key, value]) => {
                result = result.replace(`/:${key}`, `/${value}`);
            });
        }
        return result;
    }

    public generateEndpointKey(url: string, method: string, params: IKey = {}, query: IKey = {}) {
        const fullUrl = `${this.populateParamsInUrl(url, params)}${this.stringifyQuery(query)}`;
        const endpointKey = `${method}${fullUrl}`;

        return { fullUrl, endpointKey };
    }
}

diContainer.bindAsConstant(ApiUtils, new ApiUtils());
